import request from '@/config/axios'

// ========== 配额余额 ==========

export interface QuotaBalanceVO {
  id: number
  accountType: number
  accountTypeName: string
  balance: number
  totalAcquired: number
  totalUsed: number
  enterpriseName?: string
  /** 配额功能是否启用，前端根据此字段控制配额 UI 显示/隐藏 */
  enabled: boolean
}

export interface QuotaLogVO {
  id: number
  changeType: number
  changeTypeName: string
  changeAmount: number
  balanceBefore: number
  balanceAfter: number
  remark?: string
  createTime: string
}

export interface QuotaLogPageReqVO {
  pageNo?: number
  pageSize?: number
  changeType?: number
  beginTime?: string
  endTime?: string
}

// 获取配额余额
export const getQuotaBalance = async (enterpriseId?: number) => {
  const params = enterpriseId ? { enterpriseId } : {}
  return await request.get({ url: '/api/v1/member/quota/balance', params })
}

// 获取配额变动记录分页
export const getQuotaLogPage = async (params: QuotaLogPageReqVO, enterpriseId?: number) => {
  const queryParams = enterpriseId ? { ...params, enterpriseId } : params
  return await request.get({ url: '/api/v1/member/quota/log/page', params: queryParams })
}

// ========== 配额套餐 ==========

export interface QuotaPackageVO {
  id: number
  name: string
  quotaCount: number
  price: number
  originalPrice?: number
  description?: string
  sort: number
  status: number
}

// 获取上架的套餐列表
export const getPackageList = async () => {
  return await request.get({ url: '/api/v1/member/quota/package/list' })
}

// ========== 配额订单 ==========

export interface QuotaOrderVO {
  id: number
  orderNo: string
  accountId: number
  userId: number
  packageId: number
  packageName: string
  quotaCount: number
  payAmount: number
  payStatus: number
  payTime?: string
  payChannel?: string
  createTime: string
}

export interface CreateOrderReqVO {
  packageId: number
  enterpriseId?: number
}

// 创建配额订单
export const createQuotaOrder = async (data: CreateOrderReqVO) => {
  return await request.post({ url: '/api/v1/member/quota/order/create', data })
}

// 取消配额订单
export const cancelQuotaOrder = async (id: number) => {
  return await request.put({ url: `/api/v1/member/quota/order/cancel?id=${id}` })
}

// 获取订单详情
export const getQuotaOrder = async (id: number) => {
  return await request.get({ url: `/api/v1/member/quota/order/get?id=${id}` })
}

// 获取我的订单列表
export const getMyOrderPage = async (params: { pageNo?: number; pageSize?: number }) => {
  return await request.get({ url: '/api/v1/member/quota/order/my-page', params })
}

// 同步订单支付状态（前端支付成功后主动调用）
// 注意：使用 /app-api 前缀，与支付模块保持一致
export const syncOrderPayStatus = async (orderId: number) => {
  return await request.post({ url: `/api/v1/member/quota/order/sync-pay-status?orderId=${orderId}` })
}

// ========== 支付相关 ==========

export interface PayOrderVO {
  id: number
  appId: number
  subject: string
  body: string
  price: number
  status: number
  createTime: string
  expireTime: string
}

export interface PaySubmitVO {
  id: number
  channelCode: string
  returnUrl?: string
}

export interface PaySubmitRespVO {
  status: number
  displayMode: string
  displayContent: string
}

// 获取支付订单信息（PC 端 portal 接口）
export const getPayOrder = async (id: number, sync?: boolean) => {
  return await request.get({ 
    url: '/pay/order/get', 
    params: { id, sync }
  })
}

// 提交支付订单
export const submitPayOrder = async (data: PaySubmitVO) => {
  return await request.post({ url: '/pay/order/submit', data })
}

// 获取可用支付渠道列表
export const getEnableChannelCodeList = async (appId: number): Promise<string[]> => {
  return await request.get({ 
    url: '/pay/channel/get-enable-code-list', 
    params: { appId }
  })
}
